import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/user';

export class UserServiceV0 implements types.Handlers {
  private serviceEndpoint = '/users';

  constructor(private axios: AxiosInstance) {}

  async buyDesignLicense(params: types.BuyDesignLicenseParameters): Promise<void> {
    await this.axios.post<types.SuccessResponse>(
      `${this.serviceEndpoint}/me/licenses`,
      params.body,
    );
  }

  async sendContactUserEmailToSkyMapSales(
    params: types.SendContactUserEmailToSkyMapSalesParameters,
  ): Promise<void> {
    await this.axios.post<types.SuccessResponse>(
      `${this.serviceEndpoint}/me/licenses/contact`,
      params.body,
    );
  }

  async getLicensesForCurrentUser(
    params: types.GetLicensesForCurrentUserParameters,
  ): Promise<types.GetUserLicensesResponse> {
    const { data } = await this.axios.get<types.GetUserLicensesResponse>(
      `${this.serviceEndpoint}/me/licenses`,
      {
        params: new URLSearchParams([...(params.query.include ?? []).map((x) => ['include', x])]),
      },
    );
    return data;
  }

  async fetchRequestingUser(
    params: types.FetchRequestingUserParameters,
  ): Promise<types.UserByRequestResponse> {
    const { data } = await this.axios.get<types.UserByRequestResponse>(this.serviceEndpoint);
    return data;
  }
  async isUserEmailRegistered(
    params: types.IsUserEmailRegisteredParameters,
    abortController?: AbortController,
  ): Promise<void> {
    await this.axios.head(`${this.serviceEndpoint}?email=${params.query.email}`, {
      signal: abortController?.signal,
    });
  }
  async fetchAllUsers(params: types.FetchAllUsersParameters): Promise<types.UsersResponse> {
    const { data } = await this.axios.get<types.UsersResponse>(`${this.serviceEndpoint}/all`);
    return data;
  }
  fetchUserById(params: types.FetchUserByIdParameters): Promise<types.UserByIdResponse> {
    throw new Error('Method not implemented.');
  }
  create(params: types.CreateParameters): Promise<types.UserResponse> {
    throw new Error('Method not implemented.');
  }
  delete(params: types.DeleteParameters): Promise<types.SuccessResponse> {
    throw new Error('Method not implemented.');
  }
  async update(params: types.UpdateParameters): Promise<types.UserResponse> {
    return (
      await this.axios.post<types.UserResponse>(`${this.serviceEndpoint}/update`, params.body)
    ).data;
  }
  async isVerified(params: types.IsVerifiedParameters): Promise<types.IsVerifedResponse> {
    const { data } = await this.axios.get<types.IsVerifedResponse>(
      `${this.serviceEndpoint}/verification/${params.path.token}`,
    );
    return data;
  }
  async verifyRegistration(
    params: types.VerifyRegistrationParameters,
  ): Promise<types.VerifyUserResponse> {
    const { data } = await this.axios.put<types.VerifyUserResponse>(
      `${this.serviceEndpoint}/verification/${params.path.token}`,
      params.body,
    );
    return data;
  }
  async acceptCompanyAdminRequest(
    params: types.AcceptCompanyAdminRequestParameters,
  ): Promise<types.AcceptCompanyAdminRequestResponse> {
    const { data } = await this.axios.post<types.AcceptCompanyAdminRequestResponse>(
      `${this.serviceEndpoint}/acceptcompanyadminrequest`,
      params.body,
    );
    return data;
  }
  declineCompanyAdminRequest(
    params: types.DeclineCompanyAdminRequestParameters,
  ): Promise<types.SuccessResponse> {
    throw new Error('Method not implemented.');
  }
  setPassword(params: types.SetPasswordParameters): Promise<types.SuccessResponse> {
    throw new Error('Method not implemented.');
  }
}
